import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LandingPage } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class LandingPagesService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getPages() {
    return this.http.get<LandingPage[]>(`${this.BASE_URL}api/landing-pages`);
  }

  getPageBySlug(slug: string) {
    return this.http.get<LandingPage>(`${this.BASE_URL}api/landing-pages/${slug}`);
  }

  getPageById(id: number) {
    return this.http.get<LandingPage>(`${this.BASE_URL}api/landing-pages/${id}`);
  }
}
